import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal, GIButton } from 'app-components';
import Table from '@common-components/table/Table';
import { MONTHS } from '@constants/common/dateTimeValues';
import styled from 'styled-components';

const StyledModalBody = styled.div`
    .width-full {
        width: 100%;
    }

    #month-wise-data-modal-header {
        background-color: ${({ theme }) => theme.gray8};
    }

    thead th {
        background-color: ${({ theme }) => theme.gray8};
    }
`;

interface IMonthlySlcspPremium {
    month: number;
    slcsp: number;
}

interface IMonthlySlcspPremiumModalProps {
    closeModal: (modalId: string) => void;
    monthlySlcspPremium?: IMonthlySlcspPremium[];
}

export const MonthlySlcspPremiumModal: React.FC<IMonthlySlcspPremiumModalProps> = ({ closeModal, monthlySlcspPremium = [] }) => {

    const monthDataMap = new Map<number, number>();
    monthlySlcspPremium.forEach(data => {
        monthDataMap.set(data.month, data.slcsp);
    });

    const allMonthsData = MONTHS.map((monthName, index) => {
        const monthNumber = index + 1;
        return {
            monthName,
            monthNumber,
            slcsp: monthDataMap.get(monthNumber)
                ? `$${(monthDataMap.get(monthNumber) as number).toFixed(2)}`
                : 'N/A'
        };
    });

    const columns  = [
        {
            id: 'monthName',
            text: <b><FormattedMessage id="common.month" /></b>
        },
        {
            id: 'slcsp',
            text: <b><FormattedMessage id="application.eligibility.slcspPremium" /></b>
        },
    ];

    const handleClose = () => {
        closeModal('monthlySlcspPremiumModal');
    };

    return (
        <StyledModalBody>
            <Modal id="monthly-slcsp-premium-modal">
                <Modal.Header
                    id="month-wise-data-modal-header"
                    titleId="application.eligibility.totalAnnualSlcspMonthlyBreakdown"
                    onHide={handleClose}
                />
                <Modal.Body>
                    <Table 
                        id="monthly-slcsp-premium-table" 
                        columns={columns} 
                        data={allMonthsData}
                        hasPagination={false}
                    />
                </Modal.Body>
                <Modal.Controls>
                    <div>
                        <GIButton
                            id="month-wise-data-close-button"
                            labelId="button.close"
                            variant="secondary"
                            addlClassNames="width-full"
                            onClickHandler={handleClose}
                        />
                    </div>
                </Modal.Controls>
            </Modal>
        </StyledModalBody>
    );
};
